import { payApi } from '@/services/api';
import { PayingAccountFormSchema, PaymentAccountIdPathSchema } from '@/domain/paySettings/schemas';

export const payingAccountsApi = {
  getForm: payApi.endpoint({
    method: 'GET',
    url: (p: { accountId: string }) => `payment-accounts/${p.accountId}/funds/paying-accounts/form`,
    path: PaymentAccountIdPathSchema,
    response: PayingAccountFormSchema,
  }),
};
